import React, { useRef, useContext } from "react";
import { useGSAP } from "@gsap/react";
import Context from "../OriginStoryProvider";
import gsap from "gsap";
import Sizes from "../../../styles/sizes";

const PinnedImage = () => {
	const {
		data: { content, smoother },
	} = useContext(Context);

	const pinnedImgContainer = useRef(null);
	const pinnedImg = useRef(null);

	useGSAP(
		() => {
			gsap.set(pinnedImg.current, { xPercent: -50 });

			if (!smoother) return;

			let mm = gsap.matchMedia();
			mm.add(
				{
					isDesktop: `(min-width: ${Sizes.screens.large}) and (prefers-reduced-motion: no-preference)`,
				},
				() => {
					smoother.effects(pinnedImg.current, {
						speed: 1.05,
					});
				}
			);
		},
		{
			scope: pinnedImgContainer.current,
			dependencies: [content.chapters, smoother],
		}
	);

	return (
		<div className="chapter-1__pinned-img" ref={pinnedImgContainer}>
			<img
				className="chapter-1__pinned-img__bg-img"
				srcSet={`${mainScript.assetPath}images/webp/chapter-1/blaisdell-bg-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-1/blaisdell-bg-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-1/blaisdell-bg-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-1/blaisdell-bg-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-1/blaisdell-bg-1200w.webp 1200w`}
				sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (min-width: 1001px) 1200px"
				src={`${mainScript.assetPath}images/png/blaisdell-bg.png`}
				alt=""
				ref={pinnedImg}
				loading="lazy"
				width="1440"
				height="1179"
			/>
			<div className="main-grid">
				<div className="main-grid__margin"></div>
				<div className="main-grid__body">
					<div className="chapter-1__pinned-img__first-row">
						<div
							className="chapter-1__pinned-img__first-row__text"
							dangerouslySetInnerHTML={{
								__html: content.chapters.first.pinned_img.paragraph,
							}}
						></div>
						<figure className="chapter-1__pinned-img__first-row__img-container">
							<img
								className="chapter-1__pinned-img__first-row__img"
								src={`${mainScript.assetPath}images/jpg/blaisdell-young.jpg`}
								loading="lazy"
								alt=""
							/>
							<figcaption
								className="chapter-1__pinned-img__first-row__caption img-caption"
								dangerouslySetInnerHTML={{
									__html: content.chapters.first.pinned_img.img_1_caption,
								}}
							></figcaption>
						</figure>
					</div>
					<div className="chapter-1__pinned-img__second-row">
						<figure className="chapter-1__pinned-img__second-row__img-container">
							<img
								className="chapter-1__pinned-img__second-row__img"
								srcSet={`${mainScript.assetPath}images/webp/chapter-1/ellen-browning-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-1/ellen-browning-600w.webp 600w`}
								sizes="(max-width: 400px) 400px, (min-width: 401px) 600px"
								src={`${mainScript.assetPath}images/png/ellen-browning.png`}
								width="731"
								height="1105"
								loading="lazy"
								alt=""
							/>
							<figcaption className="chapter-1__pinned-img__second-row__caption img-caption">
								{content.chapters.first.pinned_img.img_2_caption}
							</figcaption>
						</figure>
					</div>
				</div>
				<div className="main-grid__margin"></div>
			</div>
		</div>
	);
};

export default PinnedImage;
